import { SnowplowService } from 'wanderu-service-analytics';

function clicked({
    navType, action, selectedCountry, unselectedCountry,
}) {
    let property = {
        nav_type: navType,
        selected_locale: selectedCountry,
    };

    if (unselectedCountry) {
        property = {
            ...property,
            unselected_locale: unselectedCountry,
        };
    }
    SnowplowService.fireStructuredEvent({
        category: 'navigation',
        action,
        label: 'country',
        property,
    });
}

export default {
    clicked,
};
